import * as angular from 'angular';

import * as paymentStatusBreakdownComponent from './payment-status-breakdown';
import * as pastPaymentsSectionComponent from './past-payments-section';
import * as paymentFrequencySection from './payment-frequency-section';
import * as paymentMethodSectionComponent from './payment-method-section';
import * as paymentSectionLabelComponent from './payment-section-label';
import * as creditCardPaymentMethod from './credit-card-payment-method';
import * as escrowPaymentMethod from './escrow-payment-method';
import * as escrowPayNow from './escrow-pay-now';
import * as creditCardPayNow from './credit-card-pay-now';
import * as stripeCard from './stripe-card';
import * as achPaymentMethod from './ach-payment-method';
import * as achPayNow from './ach-pay-now';
import * as upcomingAndPastPaymentsSectionComponent from './upcoming-and-past-payments-section';
import * as payNowWrapper from './pay-now-wrapper';

const module = angular.module('payments-page-components', [
    paymentStatusBreakdownComponent.module.name,
    pastPaymentsSectionComponent.module.name,
    paymentFrequencySection.module.name,
    paymentMethodSectionComponent.module.name,
    paymentSectionLabelComponent.module.name,
    creditCardPaymentMethod.module.name,
    escrowPaymentMethod.module.name,
    escrowPayNow.module.name,
    creditCardPayNow.module.name,
    stripeCard.module.name,
    achPaymentMethod.module.name,
    achPayNow.module.name,
    upcomingAndPastPaymentsSectionComponent.module.name,
    payNowWrapper.module.name
]);

export { module };
